import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import Basic_2511567049, { _demoInfo as Basic_2511567049_demoInfo } from "../../../../../packages/console-line-chart/demo/Basic.tsx?loadDemo";
import Multi_2511567049, { _demoInfo as Multi_2511567049_demoInfo } from "../../../../../packages/console-line-chart/demo/Multi.tsx?loadDemo";
import XLabel_2511567049, { _demoInfo as XLabel_2511567049_demoInfo } from "../../../../../packages/console-line-chart/demo/XLabel.tsx?loadDemo";
import OneDotToLine_2511567049, { _demoInfo as OneDotToLine_2511567049_demoInfo } from "../../../../../packages/console-line-chart/demo/OneDotToLine.tsx?loadDemo";
import XAxisTickInterval_2511567049, { _demoInfo as XAxisTickInterval_2511567049_demoInfo } from "../../../../../packages/console-line-chart/demo/XAxisTickInterval.tsx?loadDemo";
import XAxisAsync_2511567049, { _demoInfo as XAxisAsync_2511567049_demoInfo } from "../../../../../packages/console-line-chart/demo/XAxisAsync.tsx?loadDemo";
import YAxisMin_2511567049, { _demoInfo as YAxisMin_2511567049_demoInfo } from "../../../../../packages/console-line-chart/demo/YAxisMin.tsx?loadDemo";
import DoubleAxis_2511567049, { _demoInfo as DoubleAxis_2511567049_demoInfo } from "../../../../../packages/console-line-chart/demo/DoubleAxis.tsx?loadDemo";
import Unit_2511567049, { _demoInfo as Unit_2511567049_demoInfo } from "../../../../../packages/console-line-chart/demo/Unit.tsx?loadDemo";
import Smooth_2511567049, { _demoInfo as Smooth_2511567049_demoInfo } from "../../../../../packages/console-line-chart/demo/Smooth.tsx?loadDemo";
import Dot_2511567049, { _demoInfo as Dot_2511567049_demoInfo } from "../../../../../packages/console-line-chart/demo/Dot.tsx?loadDemo";
import Stack_2511567049, { _demoInfo as Stack_2511567049_demoInfo } from "../../../../../packages/console-line-chart/demo/Stack.tsx?loadDemo";
import GradualColor_2511567049, { _demoInfo as GradualColor_2511567049_demoInfo } from "../../../../../packages/console-line-chart/demo/GradualColor.tsx?loadDemo";
import LegendClick_2511567049, { _demoInfo as LegendClick_2511567049_demoInfo } from "../../../../../packages/console-line-chart/demo/LegendClick.tsx?loadDemo";
import React from 'react';
export default {
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  Basic_2511567049,
  Basic_2511567049_demoInfo,
  Multi_2511567049,
  Multi_2511567049_demoInfo,
  XLabel_2511567049,
  XLabel_2511567049_demoInfo,
  OneDotToLine_2511567049,
  OneDotToLine_2511567049_demoInfo,
  XAxisTickInterval_2511567049,
  XAxisTickInterval_2511567049_demoInfo,
  XAxisAsync_2511567049,
  XAxisAsync_2511567049_demoInfo,
  YAxisMin_2511567049,
  YAxisMin_2511567049_demoInfo,
  DoubleAxis_2511567049,
  DoubleAxis_2511567049_demoInfo,
  Unit_2511567049,
  Unit_2511567049_demoInfo,
  Smooth_2511567049,
  Smooth_2511567049_demoInfo,
  Dot_2511567049,
  Dot_2511567049_demoInfo,
  Stack_2511567049,
  Stack_2511567049_demoInfo,
  GradualColor_2511567049,
  GradualColor_2511567049_demoInfo,
  LegendClick_2511567049,
  LegendClick_2511567049_demoInfo,
  React
};